import { NofshonimService } from './../nofshonim.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { MenuHandler } from 'app/shared/menu-handler';
import { ENofeshType } from '../../shared/enums/enofesh-type.enum';
import { INofesh } from '../../nofesh/model/nofesh';
import { IHerkevHazmana } from '../model/herkev-hazmana';
import { UserMessagesService } from '../../shared/user-messages/user-messages.service';
import { INofshonNirsham } from '../model/nofshon-nirsham';
import { INofshonNirshamim } from '../model/nofshon-nirshamim';
import { ConfigService } from 'app/shared/config.service';
import { INofshonPayment } from '../model/nofshon-payment';
import { IOrderNofshonSubmitResponse } from '../interfaces/iorder-nofshon-submit-response.interface';
import { IOrderNofshonSubmitRequest } from '../interfaces/iorder-nofshon-submit-request.interface';
import { NofeshService } from 'app/nofesh/nofesh.service';
import { INofshonPriceType } from 'app/shared/interfaces/nofshon-price-type.interface';
import { EPriceType } from 'app/shared/enums/price-type.enum';
import { ViewportScrollPosition } from '@angular/cdk/scrolling';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { IHerkevHazmanaNofeshPnim } from '../model/herkev-hazmana-nofesh-pnim.interface';
import { IOrderNofshonSubmitRequestNofeshPnim } from '../interfaces/iorder-nofshon-submit-request-nofesh-pnim.interface';
import { MatDialog, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material';
import { ConfirmDialogComponent } from 'app/shared/dialog/confirm-dialog/confirm-dialog.component';
import { ConfirmService } from 'app/shared/dialog/confirm.service';
import { INofeshSelected } from 'app/shared/interfaces/Inofesh-selected.interface';
import { NofshonReservationTimerService } from 'app/shared/timer/nofshon-reservation-timer.service';


declare var $: any;

const ONE_MINUTE = 60;

@Component({
    moduleId: module.id,
    templateUrl: './order-nofshon-chul.component.html'
})
export class OrderNofeshChulComponent implements OnInit {
    constructor(
        private _activateRoute: ActivatedRoute,
        private _router: Router,
        private fb: FormBuilder,
        private _nofshonimService: NofshonimService,
        private _userMessagesService: UserMessagesService,
        private _confirmDialog: MatDialog,
        private _confirmService: ConfirmService,
        private _nofeshService: NofeshService,
        private _nofshonReservationTimerService: NofshonReservationTimerService
    ) {
        this.createForm();
    }

    get componentName() { return this.constructor.name; };
    isSaved: boolean = false;
    form: FormGroup;
    nofeshId: number;
    nofesh: INofesh;
    shem_prati: string;
    shem_mishpacha: string;
    quotationSubmitted: boolean = false;
    isValidHerkevHazmana: boolean = true;
    nofesh_price: number;
    ms_chadarim: number;
    is_hamtana: boolean;
    quotation_success: boolean = true;
    return_message: string;
    maxAmitim: number;
    maxNilvim: number;

    showTwoKidsSeperateRoom: boolean = false;
    showFamilyRoom: boolean = false;
    showThreeKidsSeperateRoom: boolean = false;
    showThreeKidsFaimlyRoom: boolean = false;
    showDeletmekasheret: boolean = false;
    showPremium: boolean = false;
    userSelectedNofesh: INofeshSelected

    nofeshTypeEnum: typeof ENofeshType = ENofeshType;

    get herkevHazmana() { return this.form.get("herkevHazmana"); };
    get amitim() { return this.herkevHazmana.get("ms_amit"); };
    get nilvim() { return this.herkevHazmana.get("ms_nilve"); };
    get yeladim() { return this.herkevHazmana.get("ms_yeladim"); };
    get tinokot() { return this.herkevHazmana.get("ms_tinokot"); }
    get isNofshon() { return this.nofesh.nofeshType === ENofeshType.NofeshChul || this.nofesh.nofeshType === ENofeshType.NofeshPnim || this.nofesh.nofeshType === ENofeshType.MeurganimPnim; }
    get isMishpachotChul() { return this.nofesh.nofeshType === ENofeshType.MishpachotChul; }

    createForm() {
        this.form = this.fb.group({
            herkevHazmana: this.fb.group({
                ms_amit: [1, Validators.compose([Validators.required, Validators.min(1), Validators.max(this.maxAmitim)])],
                ms_nilve: [0, Validators.compose([Validators.required, Validators.max(this.maxNilvim)])],
                ms_yeladim: [0, Validators.compose([Validators.required])],
                ms_tinokot: [0, Validators.compose([Validators.required])]
            }),
            ofen_tashlum: ["1", Validators.required],
            twoKidsSeperateRoom: [false],
            familyRoom: [false],
            threeKidsSeperateRoom: [false],
            deletMekasheret: [false]

        });
    }

    ngOnInit() {
        this._userMessagesService.clearAll();

        this.nofeshId = this._activateRoute.snapshot.params.id;
        let nofashim: INofesh[] = JSON.parse(sessionStorage.getItem("nofashim"));
        if (nofashim != null && nofashim != undefined) {
            this.nofesh = nofashim.find(t => t.id_nofesh == this.nofeshId);
        }
        if (!this.nofesh) {
            // In case nofashim is not exists in storage or nofesh not found
            this._userMessagesService.setErrorMessage("ארעה שגיאה בעת טעינת הנתונים. נא לבצע את תהליך ההזמנה שוב");
            this._router.navigate(["nofesh/home"]);
        }

        //NofeshPnim --> go to sever and get all nofesh_price_type for this nofesh. 
        this._nofshonimService.getNofshonPriceType(this.nofesh.id_nofesh).subscribe((result: ResultOfOperation<number[]>) => {
            if (result.data && result.data.length > 0) {
                result.data.forEach(type => {
                    if (type == EPriceType.TwoKidsSeperateRoom) {
                        this.showTwoKidsSeperateRoom = true;
                    }

                    if (type == EPriceType.FamilyRoom) {
                        this.showFamilyRoom = true;
                    }

                    if (type == EPriceType.ThreeKidsSeperateRoom) {
                        this.showThreeKidsSeperateRoom = true;
                    }

                    if (type == EPriceType.Deletmekasheret) {
                        this.showDeletmekasheret = true;
                    }
                });
            }

        });

        let nirshamim: INofshonNirshamim = JSON.parse(sessionStorage.getItem("nofshon-nirshamim"));
        if (nirshamim != null && nirshamim != undefined) {
            debugger
            let url: string = "";
            if (this.nofesh.nofeshType == ENofeshType.NofeshChul) {
                url = 'nofshonim-chul/pirtey-nofshim/';
            }
            else if (this.nofesh.nofeshType == ENofeshType.MishpachotChul) {
                url = 'mishpachot-chul/pirtey-nofshim/';
            }

            if (url !== "") {
                this._router.navigate([url + this.nofeshId]);
            }
            else {
                console.error("Navigation url is missing");
                // if no url, wil redirect to 'page not found' and then navigation is stuck if browser navigation buttons are used.
                // TODO: decide where to redirect
            }
            return;
        }

        MenuHandler.menuHandler($(".wiz_group"), $("#li_hazmanat_nofesh"));

        this.userSelectedNofesh = JSON.parse(sessionStorage.getItem("userSelectedNofesh"));
        if (this.userSelectedNofesh) {
            // If selected nofesh id is same as currently chosen nofesh id, and nofesh is nofshon/mishpachot chul, 
            // navigate to pirtey nofshim page.
            if (this.userSelectedNofesh.id_nofesh == this.nofeshId && this.userSelectedNofesh.isNofshon) {
                this._router.navigate(['nofshonim-chul/pirtey-nofshim/' + this.nofeshId]);
                return;
            }
            this.shem_prati = this.userSelectedNofesh.shem_prati;
            this.shem_mishpacha = this.userSelectedNofesh.shem_mishpacha;
        }

        this.maxAmitim = this.nofesh.max_adults_in_room;
        // this.maxNilvim = this.maxAmitim - 1; // Minus one because the reservation must have at least one amit.
        this.maxNilvim = 4;
    }

    showConfirmDialog() {
        const confirmDialogRef = this._confirmDialog.open(ConfirmDialogComponent, {
            width: "800px",
            data: {
                title: "אישור ביצוע הזמנה",
                content: [
                    `לתשומת לבכם, בלחיצה על כפתור 'אישור' תבוצע ההזמנה ותישמר למשך ${this._nofshonReservationTimerService.timerPeriod} דקות עד להשלמתה.`,
                    "אם ההזמנה לא תושלם בפרק זמן זה, הזמנתך תבוטל."
                ],
                confirmButtonText: "אישור הזמנה",
                declineButtonText: "סגור"
            },
            hasBackdrop: true,
            disableClose: true,
            restoreFocus: true,
            closeOnNavigation: true
        });

        const dialogSubscription = this._confirmService.confirm$.subscribe(() => {
            confirmDialogRef.close();
            dialogSubscription.unsubscribe();
            this.onSubmit();
        });

    }

    onSubmit() {
        if (this.nofesh.nofeshType !== ENofeshType.NofeshPnim && this.nofesh.nofeshType !== ENofeshType.MeurganimPnim) {
            let data: IOrderNofshonSubmitRequest = {
                mechir_le_nofesh: this.nofesh_price,
                ms_amitim: this.amitim.value,
                ms_chadarim: this.ms_chadarim,
                ms_nilvim: this.nilvim.value,
                ms_tinokot: this.tinokot.value,
                ms_yeladim: this.yeladim.value,
                nofesh_id: this.nofeshId,
                nofesh_type: this.userSelectedNofesh.nofesh_type
            };

            this._nofshonimService.saveNofshonReservation(data).subscribe(async (result: IOrderNofshonSubmitResponse) => {

                this._setStartTimerForNofshon();

                let quotation: INofshonPayment = result.quotation;
                let nirshamimResult: INofshonNirsham[] = result.nirshamim;
                if (quotation.status && (nirshamimResult != null && nirshamimResult.length > 0)) {

                    const userSelectedNofesh = await this.getUserSelectedNofesh();
                    console.log("order - user selected nofesh after save", userSelectedNofesh);
                    if (userSelectedNofesh) {
                        this.updateUserSelectedNofeshInStorage(userSelectedNofesh);
                    }

                    this.return_message = "";
                    this.quotation_success = true;
                    this.quotationSubmitted = true;

                    if (quotation.status) {
                        this.quotation_success = true;
                        this.nofesh_price = quotation.mechir_le_nofesh;
                        this.ms_chadarim = quotation.ms_chadarim;
                        this.is_hamtana = quotation.is_hamtana;
                    }
                    else {
                        this.quotation_success = false;
                        this.return_message = quotation.returnMessage;
                        this.quotationSubmitted = false;
                    }

                    let nirshamim: INofshonNirshamim = { nirshamim: nirshamimResult };
                    sessionStorage.setItem("nofshon-nirshamim", JSON.stringify(nirshamim));
                    sessionStorage.setItem('moed-rishum', this.getCurrentDate());
                    this.isSaved = true;
                    this._router.navigate(['/nofshonim-chul/pirtey-nofshim/' + this.nofeshId]);
                }
                else {
                    this._userMessagesService.setErrorMessage("בעיה ביצירת הזמנה - אנא פנה למנהל מערכת");
                }
            }, error => {
                this._userMessagesService.setErrorMessage("בעיה ביצירת הזמנה - אנא פנה למנהל מערכת");
            });

        }

        if (this.nofesh.nofeshType === ENofeshType.NofeshPnim || this.nofesh.nofeshType === ENofeshType.MeurganimPnim) {
            let data: IOrderNofshonSubmitRequestNofeshPnim = {
                mechir_le_nofesh: this.nofesh_price,
                ms_amitim: this.amitim.value,
                ms_chadarim: this.ms_chadarim,
                ms_nilvim: this.nilvim.value,
                ms_tinokot: this.tinokot.value,
                ms_yeladim: this.yeladim.value,
                nofesh_id: this.nofeshId,
                isTwoKidsSeperateRoom: this.form.value.twoKidsSeperateRoom,
                isFamilyRoom: this.form.value.familyRoom,
                isThreeKidsSeperateRoom: this.form.value.threeKidsSeperateRoom,
                isDeletMekasheret: this.form.value.deletMekasheret

            };

            this._nofshonimService.saveNofshonReservationNofeshPnim(data).subscribe(async (result: IOrderNofshonSubmitResponse) => {
                this._setStartTimerForNofshon();

                let quotation: INofshonPayment = result.quotation;
                let nirshamimResult: INofshonNirsham[] = result.nirshamim;
                if (quotation.status && (nirshamimResult != null && nirshamimResult.length > 0)) {
                    const userSelectedNofesh = await this.getUserSelectedNofesh();
                    console.log("order - user selected nofesh after save", userSelectedNofesh);
                    if (userSelectedNofesh) {
                        this.updateUserSelectedNofeshInStorage(userSelectedNofesh);
                    }

                    this.return_message = "";
                    this.quotation_success = true;
                    this.quotationSubmitted = true;

                    if (quotation.status) {
                        this.quotation_success = true;
                        this.nofesh_price = quotation.mechir_le_nofesh;
                        this.ms_chadarim = quotation.ms_chadarim;
                        this.is_hamtana = quotation.is_hamtana;
                    }
                    else {
                        this.quotation_success = false;
                        this.return_message = quotation.returnMessage;
                        this.quotationSubmitted = false;
                    }

                    let nirshamim: INofshonNirshamim = { nirshamim: nirshamimResult };
                    sessionStorage.setItem("nofshon-nirshamim", JSON.stringify(nirshamim));
                    sessionStorage.setItem('moed-rishum', this.getCurrentDate());
                    this.isSaved = true;
                    this._router.navigate(['/nofesh-pnim/pirtey-nofshim/' + this.nofeshId]);
                }
                else {
                    this._userMessagesService.setErrorMessage("אנו מתנצלים, אזלו המוקמות לנופש זה (C)");
                }
            }, error => {
                this._userMessagesService.setErrorMessage("בעיה ביצירת הזמנה - אנא פנה למנהל מערכת");
            });
        }
    }

    private _setStartTimerForNofshon(): void {
        if (this.nofesh && this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh)) {
            sessionStorage.setItem("startTimer", "true");
        }
    }

    getUserSelectedNofesh(): Promise<INofeshSelected> {
        //debugger
        return this._nofeshService.getUserSelectedNofesh(this.nofeshId).toPromise();
    }

    updateUserSelectedNofeshInStorage(userSelectedNofesh: INofeshSelected): void {
        sessionStorage.removeItem("userSelectedNofesh");
        sessionStorage.setItem("userSelectedNofesh", JSON.stringify(userSelectedNofesh));
    }

    getNofshonQuotationOnly() {
        if ((this.amitim.value + this.nilvim.value) > this.nofesh.max_adults_in_room) {
            this.quotation_success = false;
            this.return_message = `ניתן לבחור עד ${this.nofesh.max_adults_in_room} מבוגרים בחדר`;
            return;
        }
        if (this.nofesh.max_child_in_room > 0 && (this.yeladim.value + this.tinokot.value) > this.nofesh.max_child_in_room) {
            this.quotation_success = false;
            if (this.nofesh.nofeshType === ENofeshType.NofeshChul) {
                this.return_message = `ניתן לבחור עד ${this.nofesh.max_child_in_room} ילדים/תינוקות בחדר`;
            }
            else if (this.nofesh.nofeshType === ENofeshType.MishpachotChul) {
                this.return_message = `ניתן לבחור עד ${this.nofesh.max_child_in_room} ילדים בחדר`;
            }
            return;
        }

        // Reset return message and quotation success if an error message was shown.
        this.return_message = "";
        this.quotation_success = true;

        let herkevHazmana: IHerkevHazmana = {
            nofesh_id: this.nofeshId,
            ms_amit: this.amitim.value,
            ms_nilve: this.nilvim.value,
            ms_yeladim: this.yeladim.value,
            ms_tinokot: this.tinokot.value
        };
        this._nofshonimService.getNofshonQuotationOnly(herkevHazmana).subscribe(
            res => {
                this.quotationSubmitted = true;
                if (!res.status) {
                    this.quotation_success = false;
                    this.return_message = res.returnMessage;
                    this.quotationSubmitted = false;
                }
                else {
                    this.quotation_success = true;
                    this.nofesh_price = res.mechir_le_nofesh;
                    this.ms_chadarim = res.ms_chadarim;
                    this.is_hamtana = res.is_hamtana;
                }

            },
            error => {
                this.quotation_success = false;
                this.return_message = "לא נמצאה התאמה לבקשה אנא נסה שנית";
                this.quotationSubmitted = false;
            });
    }

    getNofshonQuotationOnlyNofeshPnim() {

        if ((this.amitim.value + this.nilvim.value) > this.nofesh.max_adults_in_room) {
            this.quotation_success = false;
            this.return_message = `ניתן לבחור עד ${this.nofesh.max_adults_in_room} מבוגרים בחדר`;
            return;
        }
        if (this.nofesh.max_child_in_room > 0 && (this.yeladim.value + this.tinokot.value) > this.nofesh.max_child_in_room) {
            this.quotation_success = false;
            if (this.nofesh.nofeshType === ENofeshType.NofeshChul) {
                this.return_message = `ניתן לבחור עד ${this.nofesh.max_child_in_room} ילדים/תינוקות בחדר`;
            }
            else if (this.nofesh.nofeshType === ENofeshType.MishpachotChul) {
                this.return_message = `ניתן לבחור עד ${this.nofesh.max_child_in_room} ילדים בחדר`;
            }
            return;
        }

        // Reset return message and quotation success if an error message was shown.
        this.return_message = "";
        this.quotation_success = true;

        let herkevHazmana: IHerkevHazmanaNofeshPnim = {
            nofeshId: this.nofeshId,
            msAmit: this.amitim.value,
            msNilve: this.nilvim.value,
            msYeladim: this.yeladim.value,
            msTinokot: this.tinokot.value,
            isTwoKidsSeperateRoom: this.form.value.twoKidsSeperateRoom,
            isFamilyRoom: this.form.value.familyRoom,
            isThreeKidsSeperateRoom: this.form.value.threeKidsSeperateRoom,
            isDeletMekasheret: this.form.value.deletMekasheret

        };
        this._nofshonimService.getNofshonQuotationOnlyNofeshPnim(herkevHazmana).subscribe(
            res => {
                this.quotationSubmitted = true;
                if (!res.status) {
                    this.quotation_success = false;
                    this.return_message = res.returnMessage;
                    this.quotationSubmitted = false;
                }
                else {
                    this.quotation_success = true;
                    this.nofesh_price = res.mechir_le_nofesh;
                    this.ms_chadarim = res.ms_chadarim;
                    this.is_hamtana = res.is_hamtana;
                }
            },
            error => {
                this.quotation_success = false;
                this.return_message = "לא נמצאה התאמה לבקשה אנא נסה שנית";
                this.quotationSubmitted = false;
            });
    }

    getNofshonQuotation() {

        /*
        if((this.amitim.value + this.nilvim.value) > this.nofesh.max_adults_in_room)
        {
            this.quotation_success = false;
            this.return_message = `ניתן לבחור עד ${this.nofesh.max_adults_in_room} מבוגרים בחדר`;
            return;
        }
        if(this.nofesh.max_child_in_room > 0 && (this.yeladim.value + this.tinokot.value) > this.nofesh.max_child_in_room)
        {
            this.quotation_success = false;
            if(this.nofesh.nofeshType === ENofeshType.NofeshChul)
            {
                this.return_message = `ניתן לבחור עד ${this.nofesh.max_child_in_room} ילדים/תינוקות בחדר`;
            }
            else if(this.nofesh.nofeshType === ENofeshType.MishpachotChul)
            {
                this.return_message = `ניתן לבחור עד ${this.nofesh.max_child_in_room} ילדים בחדר`;
            }
            return;
        }
        
        
        // Reset return message and quotation success if an error message was shown.
        this.return_message = "";
        this.quotation_success = true;
        
        let herkevHazmana: IHerkevHazmana = {
            nofesh_id: this.nofeshId,
            ms_amit: this.amitim.value,
            ms_nilve: this.nilvim.value,
            ms_yeladim: this.yeladim.value,
            ms_tinokot: this.tinokot.value
        };

        this._nofshonimService.getNofshonQuotation(herkevHazmana).subscribe(
            res => {
                debugger
                this.quotationSubmitted = true;
                if (!res.status){
                    this.quotation_success = false;
                    this.return_message = res.returnMessage; 
                    this.quotationSubmitted = false;   
                            
                }
                else{
                    this.quotation_success = true;
                 this.nofesh_price = res.mechir_le_nofesh;
                 this.ms_chadarim = res.ms_chadarim;
                 this.is_hamtana = res.is_hamtana;
                }
            }, 
            error => {
                this.quotation_success = false;
                this.return_message = "לא נמצאה התאמה לבקשה אנא נסה שנית"; 
                this.quotationSubmitted = false;
                
        });
        */
    }

    newCalculation() {
        this.quotationSubmitted = false;
    }

    getCurrentDate() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        var hours = today.getHours();
        var minutes = today.getMinutes();
        var _dd: string;
        var _mm: string;
        var _today: string;

        if (dd < 10) {
            _dd = '0' + dd
        }

        if (mm < 10) {
            _mm = '0' + mm
        }

        _today = mm + '/' + dd + '/' + yyyy + '  ,' + hours + ':' + minutes;
        return _today;
    }




}
